var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75879 12.9279L9.00879 14.1779L12.3421 10.8445",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 5.67788H11.667C13.3337 5.67788 13.3337 4.84454 13.3337 4.01121C13.3337 2.34454 12.5003 2.34454 11.667 2.34454H8.33366C7.50033 2.34454 6.66699 2.34454 6.66699 4.01121C6.66699 5.67788 7.50033 5.67788 8.33366 5.67788Z",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.02783C16.1083 4.17783 17.5 5.20283 17.5 9.01116V14.0112C17.5 17.3445 16.6667 19.0112 12.5 19.0112H7.5C3.33333 19.0112 2.5 17.3445 2.5 14.0112V9.01116C2.5 5.21117 3.89167 4.17783 6.66667 4.02783",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskApproval);
export default __webpack_public_path__ + "static/media/task_approval.bba7fe1dc2d30a5bbfe0677c39881342.svg";
export { ForwardRef as ReactComponent };